import { Component, OnInit } from '@angular/core';
import { WordpressService } from '../services/wordpress.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
export class ContactsComponent implements OnInit {
  public form = {
      name: '',
      email: '',
      phone: '',
      company: '',
      country: '',
      city: '',
      message: ''
  };

  constructor(private wordpressService: WordpressService ) { }

  ngOnInit( ) {
  }

  sendEmail() {
    this.wordpressService.testEmail(this.form);
  }

}



// WEBPACK FOOTER //
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/contacts/contacts.component.ts